import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { OpenLinkInNewWindowDirective } from '../../shared/directives/open-link-in-new-window.directive';
import { Enums } from '../../shared/models/enums';
import { ModalService } from '../../shared/services/modal.service';
import { ModalFeedbackComponent } from '../../shared/widgets';
import { UserPersistenceService } from '../services/userPersistence.service';

@Component({
    selector: 'app-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [OpenLinkInNewWindowDirective, RouterLink]
})
export class FooterComponent {
    confirmationStatus = Enums.confirmationStatus;

    constructor(private modalService: ModalService,
        private router: Router,
        public userPersistenceService: UserPersistenceService ) { }

    feedback() {
        const modalOptions = {
            class: 'modal-centre-screen',
            containerClass: 'right',
            ignoreBackdropClick: true,
            keyboard: false,
        };

        this.modalService.openModal(ModalFeedbackComponent, modalOptions);
    }

    navigateToWordpress() {
        this.router.navigate(['/user/wordpress']);
    }
}
